import { createRouter, createWebHashHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("@/views/home"),
  },
  {
    path: "/service",
    name: "Service",
    component: () =>
      import("../views/service"),
  },
  {
    path: "/community",
    name: "Community",
    component: () =>
      import("../views/community"),
  },
    {
    path: "/transaction",
    name: "Transaction",
    component: () =>
      import("../views/transaction"),
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
